module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Knife2-e090c326ae934872e2130935fcc1335e.svg";